// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-StudyList-ReferenceToggle-module__icon";
export { _1 as "icon" }
